import SummaryItem from 'components/SummaryItem/SummaryItem'
import { translateManager as t } from 'services/TranslateManager'
import { formatPrice } from '../../../../../utils/utils'
import * as S from './MinimumOrderFeeSummaryItem.styles'

function MinimumOrderFeeSummaryItem({
  orderFeePrice,
  currency,
  minimumOrderPrice,
}) {
  return (
    <SummaryItem
      text={t.get('order.checkout.minimum_order_fee.title')}
      testId="minimum-order-fee-summary-item"
      description={t.get('order.checkout.minimum_order_fee.description', {
        v1: formatPrice(minimumOrderPrice, currency),
      })}
      descriptionPrefixNode={<S.Divider orientation="vertical" color="black" />}
    >
      {formatPrice(orderFeePrice, currency)}
    </SummaryItem>
  )
}

export default MinimumOrderFeeSummaryItem
